function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.147 25.702a1.005 1.005 0 001.427 0l17.13-17.248a1.022 1.022 0 000-1.438l-.713-.718a1.004 1.004 0 00-1.428 0l-15.56 15.667a.2.2 0 01-.285 0l-6.281-6.324a1.004 1.004 0 00-1.428 0l-.713.718a1.021 1.021 0 000 1.438l7.85 7.905z",
  fill: "currentColor"
})));